var map = {
	"./admin_settings.png": 1438,
	"./catalog.png": 1439,
	"./catalog_order.png": 1440,
	"./cms.png": 1441,
	"./component-fields/Asset.png": 1442,
	"./component-fields/Blocks.png": 1443,
	"./component-fields/Boolean.png": 1444,
	"./component-fields/Date-time.png": 1445,
	"./component-fields/LInk.png": 1446,
	"./component-fields/Markdown.png": 1447,
	"./component-fields/Multi asset.png": 1448,
	"./component-fields/Multi options.png": 1449,
	"./component-fields/Number.png": 1450,
	"./component-fields/Richtext.png": 1451,
	"./component-fields/Single options.png": 1452,
	"./component-fields/Table.png": 1453,
	"./component-fields/Text area.png": 1454,
	"./component-fields/Text.png": 1455,
	"./components.png": 1456,
	"./configuration.png": 1457,
	"./contents.png": 1458,
	"./custom_order.png": 1459,
	"./customer_credits.png": 1460,
	"./dashboard.png": 1461,
	"./dashboard_available_credit.png": 1462,
	"./dashboard_due_soon.png": 1463,
	"./dashboard_invoices.png": 1464,
	"./dashboard_market.png": 1465,
	"./dashboard_messages.png": 1466,
	"./dashboard_new_arrivals.png": 1333,
	"./dashboard_new_catalog_order.png": 1328,
	"./dashboard_new_custom_order.png": 1330,
	"./dashboard_new_estimate.png": 1329,
	"./dashboard_new_payment.png": 1332,
	"./dashboard_new_repair.png": 1331,
	"./dashboard_orders.png": 1467,
	"./dashboard_past_due.png": 1468,
	"./dashboard_quotes.png": 1469,
	"./dashboard_sales_orders.png": 1470,
	"./dashboard_total_payable.png": 1471,
	"./estimate.png": 1472,
	"./financials.png": 1473,
	"./home.png": 1474,
	"./invoices.png": 1475,
	"./media_library.png": 1476,
	"./move.png": 1477,
	"./order_creation.png": 1478,
	"./orders.png": 1479,
	"./payment-methods/amex.png": 1199,
	"./payment-methods/discover.png": 1204,
	"./payment-methods/mastercard.png": 1205,
	"./payment-methods/visa.png": 1206,
	"./payment.png": 1480,
	"./product_catalog.png": 1481,
	"./products.png": 1482,
	"./quote-icon.png": 1483,
	"./quotes.png": 1484,
	"./quotes_approve.png": 1485,
	"./repair_order.png": 1486,
	"./sales_orders.png": 1487,
	"./status_tracking.png": 1488
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1227;